import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, Divider, Row, Col, Upload, message, Image, Popconfirm, Spin } from 'antd';
import { UploadOutlined, CloseCircleOutlined, InboxOutlined } from '@ant-design/icons';
import PhoneInput from 'react-phone-input-2';
import { changeExtensiontoLowerCase, formatAddress, formatPhoneNumber, getPreSignedUrls, uploadFileToS3 } from '../../Common/utils/extraFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { TitleOffice } from './TitleOffice';
import { TitleRepsCloser } from './TitleRepsCloser';
import { transactionLaneDataHandle } from '../state/actions';
import imageCompression from 'browser-image-compression';
import { useHistory, useLocation } from 'react-router-dom';

const { Dragger } = Upload;

function EditTitleCompanyModal({
    showTitleCompanyEditModal,
    setShowTitleCompanyEditModal,
    selectedData,
    companyModalStep,
    setCompanyModalStep,
    getTitleCompanySelectedData,
    offerId,
    propertyId,
    source,
}) {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [fileData, setFileData] = useState(null);
    const [imageData, setImageData] = useState({
        bufferData: null,
        imageLink: null
    });

    const [auxiliaryModalState, setAuxiliaryModalState] = useState({
        openTitleOfficeModal: false,
        openTitleCloserModal: {
            openModal: false,
            target: null,
        },
        
        updatingData: {
            titleCompany: null,
            titleOffice: null,
            titleCloser: null,
            salesRep: null,
        }
    });

    const { editTitleCompanyDataInOfferLoading } = useSelector((state) => state.rtdTransactionLane);
    const history = useHistory();
    const { pathname } = useLocation();
    const redirectFunc = () => {
        history.push({
            pathname,
            state: {
                category: ((selectedData?.isProperty) ? "SELLER" : "BUYER"),
                categoryId: ((selectedData?.isProperty) ? selectedData.propertyId : selectedData.offerId)
            }
        })
    }

    const handleFinish = async (values) => {

        if (!(auxiliaryModalState?.updatingData?.salesRep?._id || auxiliaryModalState?.updatingData?.titleCloser?._id)) {
            if (!(values?.titleCloserName && values?.titleCloserEmail) && !(values?.salesRepName && values?.salesRepEmail)) {
                message.error('Please fill either Closer or Sales Rep details!');
                return;
            }
        }
        if (!auxiliaryModalState?.updatingData?.titleCloser?._id && values?.titleCloserName && !values?.titleCloserEmail) {
            message.error('Please fill the Closer Email if Closer name is present!');
            return;
        }
        if (!auxiliaryModalState?.updatingData?.titleCloser?._id && values?.titleCloserEmail && !values?.titleCloserName) {
            message.error('Please fill the Closer Name if Closer Email is present!');
            return;
        }
        if (!auxiliaryModalState?.updatingData?.salesRep?._id && values?.salesRepName && !values?.salesRepEmail) {
            message.error('Please fill the Sales Rep Email if Sales Rep name is present!');
            return;
        }
        if (!auxiliaryModalState?.updatingData?.salesRep?._id && values?.salesRepEmail && !values?.salesRepName) {
            message.error('Please fill the Sales Rep Name if Sales Rep Email is present!');
            return;
        }

        let uploadedFilesInfo = [];
        let finalImageLink = imageData?.imageLink;

        if (imageData?.bufferData) {
            uploadedFilesInfo = await uploadImagesToS3(imageData.bufferData);
            if (uploadedFilesInfo[0]) {
                finalImageLink = uploadedFilesInfo[0];
            }
        }

        let payload = {
            selectedBy: getTitleCompanySelectedData?.selectedBy,
            inBuilt: getTitleCompanySelectedData?.inBuilt,
            ...(getTitleCompanySelectedData?.inBuilt ? {
                ...(getTitleCompanySelectedData?.titleCompanyId ? { titleCompanyId: getTitleCompanySelectedData?.titleCompanyId } : {}),
                ...(auxiliaryModalState?.updatingData?.titleOffice?._id ? { titleOfficeId: auxiliaryModalState?.updatingData?.titleOffice?._id } : {}),
            } : {
                ...(values?.titleCompanyName ? { titleCompanyName: values?.titleCompanyName } : {}),
                ...(finalImageLink ? { titleCompanyLogo: finalImageLink } : (imageData?.imageLink ? { titleCompanyLogo: imageData?.imageLink } : {})),
                ...(values?.titleOfficeName ? { titleOfficeName: values?.titleOfficeName } : {}),
                ...(values?.titleOfficeAddress ? { titleOfficeAddress: values?.titleOfficeAddress } : {}),
                ...(values?.titleOfficeEmail ? { titleOfficeEmail: values?.titleOfficeEmail } : {}),
                ...(values?.titleOfficePhoneNo ? { titleOfficePhone: formatPhoneNumber(values?.titleOfficePhoneNo) } : {}),
                ...(values?.titleOfficeFaxNo ? { titleOfficeFaxNo: formatPhoneNumber(values?.titleOfficeFaxNo) } : {}),
            }),

            ...(auxiliaryModalState?.updatingData?.salesRep?._id ? {
                salesRepId: auxiliaryModalState?.updatingData?.salesRep?._id
            } : {
                ...(values?.salesRepName ? { salesRepName: values?.salesRepName } : {}),
                ...(values?.salesRepEmail ? { salesRepEmail: values?.salesRepEmail } : {}),
                ...(values?.salesRepPhone ? { salesRepPhone: formatPhoneNumber(values?.salesRepPhone) } : {}),
            }),

            ...(auxiliaryModalState?.updatingData?.titleCloser?._id ? {
                titleCloserId: auxiliaryModalState?.updatingData?.titleCloser?._id
            } : {
                ...(values?.titleCloserName ? { titleCloserName: values?.titleCloserName } : {}),
                ...(values?.titleCloserEmail ? { titleCloserEmail: values?.titleCloserEmail } : {}),
                ...(values?.titleCloserPhone ? { titleCloserPhone: formatPhoneNumber(values?.titleCloserPhone) } : {}),
            }),

            ...(values?.processors && values?.processors.length > 0 ? {
                processors: values?.processors?.map((processor) => ({
                    name: processor?.name || '',
                    email: processor?.email || '',
                    phoneNumber: formatPhoneNumber(processor?.phoneNumber) || '',
                }))
            } : {}),

            // ...(values?.affiliateDetails?.affiliates && values?.affiliateDetails?.affiliates.length > 0 ? {
            //     affiliates: values?.affiliateDetails?.affiliates?.map((affiliate) => ({
            //         name: affiliate?.name || '',
            //         email: affiliate?.email || '',
            //         role: affiliate?.role || '',
            //         phoneNumber: formatPhoneNumber(affiliate?.phoneNumber) || '',
            //     }))
            // } : {}),
        }

        dispatch(transactionLaneDataHandle?.editTitleCompanyDataInOffer({payload, offerId, handleResetAndClose, source, propertyId, redirectFunc}))
    };

    const handleResetAndClose = () => {
        // CLOSE THE MODAL AND RESET EVERYTHING
        setLoading(false); // Stop loading
        if (editTitleCompanyDataInOfferLoading === false) {
            setShowTitleCompanyEditModal((prev) => ({ ...prev, open: false })); // Close the modal
        }
        setImageData({ bufferData: null, imageLink: null }); // Reset image data
        setAuxiliaryModalState({
            openTitleOfficeModal: false,
            openTitleCloserModal: { openModal: false, target: null },
            updatingData: { titleOffice: null, titleCloser: null, salesRep: null }
        }); // Reset auxiliary modal state
        setCompanyModalStep((prev) => ({
            ...prev,
            titleCompany: '',
            titleOffice: '',
            titleCloser: '',
            salesRep: '',
        }));
        form.resetFields(); // Reset the form fields
    }

    useEffect(() => {
        if (getTitleCompanySelectedData) {
            setCompanyModalStep((prev) => ({
                ...prev,
                inBuilt: getTitleCompanySelectedData?.inBuilt || false,
            }));
            form.setFieldsValue({
                ...getTitleCompanySelectedData,
                processors: getTitleCompanySelectedData.processors || [],
                // affiliateDetails: getTitleCompanySelectedData.affiliateDetails || {},
            });
            if (getTitleCompanySelectedData?.titleCompanyLogo?.length > 0) {
                setImageData((prev) => ({
                    ...prev,
                    imageLink: getTitleCompanySelectedData.titleCompanyLogo,
                }));
            }
            setAuxiliaryModalState((prev) => ({
                ...prev,
                updatingData: {
                    ...prev.updatingData,
                    titleOffice: {
                        ...(getTitleCompanySelectedData?.titleOfficeId ? { _id: getTitleCompanySelectedData.titleOfficeId } : {}),
                        ...(getTitleCompanySelectedData?.titleCompanyName ? { titleCompanyName: getTitleCompanySelectedData.titleCompanyName } : {}),
                        ...(getTitleCompanySelectedData?.titleOfficeEmail ? { titleOfficeEmail: getTitleCompanySelectedData.titleOfficeEmail } : {}),
                        ...(getTitleCompanySelectedData?.titleOfficePhoneNo ? { titleOfficePhone: formatPhoneNumber(getTitleCompanySelectedData.titleOfficePhoneNo) } : {}),
                        ...(getTitleCompanySelectedData?.titleOfficeFaxNo ? { titleOfficeFaxNo: formatPhoneNumber(getTitleCompanySelectedData.titleOfficeFaxNo) } : {}),
                        ...(getTitleCompanySelectedData?.titleOfficeAddress ? { titleOfficeAddress: getTitleCompanySelectedData.titleOfficeAddress } : {}),
                    },
                    titleCompany: {
                        ...(getTitleCompanySelectedData?.titleCompanyId ? { _id: getTitleCompanySelectedData.titleCompanyId } : {}),
                        ...(getTitleCompanySelectedData?.titleCompanyLogo ? { titleCompanyLogo: getTitleCompanySelectedData.titleCompanyLogo } : {}),
                        ...(getTitleCompanySelectedData?.titleCompanyEmail ? { titleCompanyEmail: getTitleCompanySelectedData.titleCompanyEmail } : {}),
                    },
                    titleCloser: {
                        ...(getTitleCompanySelectedData?.titleCloserId ? { _id: getTitleCompanySelectedData.titleCloserId } : {}),
                        ...(getTitleCompanySelectedData?.titleCloserName ? { titleCloserName: getTitleCompanySelectedData.titleCloserName } : {}),
                        ...(getTitleCompanySelectedData?.titleCloserEmail ? { titleCloserEmail: getTitleCompanySelectedData.titleCloserEmail } : {}),
                        ...(getTitleCompanySelectedData?.titleCloserPhone ? { titleCloserPhone: formatPhoneNumber(getTitleCompanySelectedData.titleCloserPhone) } : {}),
                    },
                    salesRep: {
                        ...(getTitleCompanySelectedData?.salesRepId ? { _id: getTitleCompanySelectedData.salesRepId } : {}),
                        ...(getTitleCompanySelectedData?.salesRepName ? { salesRepName: getTitleCompanySelectedData.salesRepName } : {}),
                        ...(getTitleCompanySelectedData?.salesRepEmail ? { salesRepEmail: getTitleCompanySelectedData.salesRepEmail } : {}),
                        ...(getTitleCompanySelectedData?.salesRepPhone ? { salesRepPhone: formatPhoneNumber(getTitleCompanySelectedData.salesRepPhone) } : {}),
                    }
                }
            }));
        }
    }, [getTitleCompanySelectedData]);

    const updateTheForm = ({ auxiliaryModalState, updatedWhat }) => {

        if (updatedWhat === 'TITLE_OFFICE_DATA') {
            const titleOfficeData = auxiliaryModalState?.updatingData?.titleOffice;
            if (titleOfficeData) {
                form.setFieldsValue({
                    titleOfficeName: titleOfficeData?.name,
                    titleOfficeAddress: formatAddress(titleOfficeData?.address),
                    titleOfficeEmail: titleOfficeData?.email,
                    titleOfficePhone: formatPhoneNumber(titleOfficeData?.phoneNumber),
                    titleOfficeFaxNo: formatPhoneNumber(titleOfficeData?.faxNumber),
                });
            }
        }
        else if (updatedWhat === 'TITLE_CLOSER_DATA') {
            const titleCloserData = auxiliaryModalState?.updatingData?.titleCloser;
            const salesRepData = auxiliaryModalState?.updatingData?.salesRep;
            if (titleCloserData) {
                form.setFieldsValue({
                    titleCloserName: titleCloserData?.name || titleCloserData?.titleCloserName,
                    titleCloserEmail: titleCloserData?.email || titleCloserData?.titleCloserEmail,
                    titleCloserPhone: formatPhoneNumber(titleCloserData?.phoneNumber) || formatPhoneNumber(titleCloserData?.titleCloserPhone),
                });
            }
            if (salesRepData) {
                form.setFieldsValue({
                    salesRepName: salesRepData?.name || salesRepData?.salesRepName,
                    salesRepEmail: salesRepData?.email || salesRepData?.salesRepEmail,
                    salesRepPhone: formatPhoneNumber(salesRepData?.phoneNumber) || formatPhoneNumber(salesRepData?.salesRepPhone),
                });
            }
        }
    }
    
    async function compressImage(file) {
        const maxSizeMB = 3;
        const maxSizeBytes = maxSizeMB * 1024 * 1024;
        if (file.size <= maxSizeBytes) {
            return file;
        }

        const initialQuality = 0.7;
        let currentQuality = initialQuality;

        while (true) {
            try {
                const compressedFile = await imageCompression(file, { quality: currentQuality });
                if (compressedFile.size <= maxSizeBytes || currentQuality <= 0.1) {
                    return compressedFile;
                }
                currentQuality -= 0.1;
            } catch (error) {
                throw error;
            }
        }
    }

    function bytesToSize(bytes) {
        let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) return "0 Byte";
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    }

    let handleCustom = async (data) => {
        const rawFile = data?.file?.originFileObj || data?.file;
        setFileData(rawFile)
        const image = await compressImage(data.file)
        const reader = new FileReader();
        reader.readAsDataURL(data.file);
        reader.onload = () => {
            const newFile = {
                name: data.file.name,
                size: bytesToSize(image.size),
                file: reader.result,
                origin: "notBase64",
            };
            setImageData((prev) => ({
                ...prev,
                bufferData: newFile,
                imageLink: null // Clear previous image link if any
            }));
        };
        reader.onerror = (error) => {
            return error;
        };
    };
    
    const uploadImagesToS3 = async (imageBuffers) => {
        try {
            setLoading(true); // 🔥 start loading
            if (!imageBuffers || (Array.isArray(imageBuffers) && imageBuffers.length === 0)) {
                message.error("No files to upload.");
                return null;
            }

            const fileName = changeExtensiontoLowerCase(imageBuffers.name);
            const fileList = [fileName];
            const preSignedUrls = await getPreSignedUrls(fileList, "TRANSACTION");

            if (!preSignedUrls || preSignedUrls.length === 0) {
                message.error("No valid files to upload.");
                return null;
            }

            const uploadedFilesInfo = [];

            const { url: uploadUrl } = preSignedUrls.find(
                (item) => item?.fileName === fileData?.name
            ) || {};

            if (!uploadUrl) {
                message.error(`URL not found for file: ${fileData?.name}`);
            } else {
                const finalFileLink = await uploadFileToS3(fileData, uploadUrl);
                uploadedFilesInfo.push(finalFileLink);
            }

            return uploadedFilesInfo;
        } catch (error) {
            message.error("Upload failed. Please try again.");
            return null;
        } finally {
            setLoading(false); // 🔥 stop loading (even if error happens)
        }
    };

    return (
        <Modal
            open={showTitleCompanyEditModal.open}
            onCancel={() => setShowTitleCompanyEditModal((prev) => ({ ...prev, open: false }))}
            width={800}
            footer={
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Button onClick={() => setShowTitleCompanyEditModal((prev) => ({ ...prev, open: false }))}>
                        Cancel
                    </Button>
                    <Button type="primary" onClick={() => form.submit()} loading={loading} disabled={loading}>
                        {loading ? 'Updating...' : 'Update'}
                    </Button>
                </div>
            }
            title={<div className="commonModalTitle" style={{ color: '#2697FF' }}>Edit Title Company</div>}
            style={{ marginTop: -50 }}
            bodyStyle={{ padding: 5 }}
        >
            <div style={{ height: '68vh', overflowY: 'auto', overflowX: 'hidden' }}>
                {editTitleCompanyDataInOfferLoading && <div style={{ position: "fixed", zIndex: 5, width: "100%", height: "100vh", top: 0, left: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spin size="large" />
                </div>}
                <Form layout="vertical" form={form} onFinish={handleFinish} style={{ margin: 15 }}>
                    {/* LOGO */}
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {
                            getTitleCompanySelectedData?.inBuilt ?
                                <img
                                    src={getTitleCompanySelectedData?.titleCompanyLogo}
                                    alt="Logo"
                                    style={{ height: 80, objectFit: 'contain', marginBottom: 8 }}
                                /> :
                                <Form.Item style={{ width: "50%", display: 'flex', justifyContent: 'center' }}>
                                    {loading ? <Spin /> : (imageData?.imageLink || imageData?.bufferData) ? (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: 'center',
                                                // maxWidth: "100%",
                                                overflow: "auto",
                                                // minHeight: "100px",
                                                boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                            }}
                                        >
                                            <div style={{ margin: "10px" }}>
                                                <Image
                                                    width={70}
                                                    src={imageData?.imageLink || imageData?.bufferData.file}
                                                    preview={{
                                                        visible: false,
                                                        mask: (
                                                            <div
                                                                style={{
                                                                    cursor: "pointer",
                                                                    position: "absolute",
                                                                    zIndex: 21,
                                                                    top: "0px",
                                                                    right: "0px",
                                                                }}
                                                            >
                                                                <div
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                    }}
                                                                >
                                                                    <Popconfirm
                                                                        title="Are you sure you want to delete this image?"
                                                                        onConfirm={() => {
                                                                            setImageData({
                                                                                bufferData: null,
                                                                                imageLink: null
                                                                            })
                                                                        }}
                                                                        okText="Yes"
                                                                        cancelText="No"
                                                                    >
                                                                        <CloseCircleOutlined
                                                                            style={{ fontSize: "30px" }}
                                                                        />
                                                                    </Popconfirm>
                                                                </div>
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <Dragger
                                            accept="image/*"
                                            showUploadList={false}
                                            customRequest={handleCustom}
                                        >
                                            <div style={{ height: "100px" }}>
                                                <p className="ant-upload-drag-icon">
                                                    <InboxOutlined
                                                        style={{ position: "relative", top: "-25px" }}
                                                    />
                                                </p>
                                                <p
                                                    className="ant-upload-text"
                                                    style={{ position: "relative", top: "-55px" }}
                                                >
                                                    Click or drag file to this area to upload
                                                </p>
                                                <p
                                                    className="ant-upload-hint"
                                                    style={{ position: "relative", top: "-55px" }}
                                                >
                                                    Strictly prohibit from uploading company data or other banned files
                                                </p>
                                            </div>
                                        </Dragger>
                                    )}
                                </Form.Item>
                        }
                    </div>

                    {/* SECTION: Title Company Details */}
                    <Divider orientation="center" style={{ color: '#2697FF' }}>TITLE COMPANY DETAILS</Divider>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Title Company Name" name="titleCompanyName" rules={[{ required: true, message: 'Please enter Title Company Name' }]}>
                                <Input placeholder='Title Company Name...' disabled={getTitleCompanySelectedData?.inBuilt} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Title Office Name" name="titleOfficeName" rules={[{ required: true, message: 'Please enter Title Office Name' }]}>
                                <Input
                                    placeholder="Title Office Name..."
                                    readOnly={getTitleCompanySelectedData?.inBuilt} // Prevent typing when inBuilt is true
                                    onClick={() => {
                                        if (getTitleCompanySelectedData?.inBuilt && getTitleCompanySelectedData?.titleCompanyId) {
                                            setAuxiliaryModalState((prev) => ({...prev, openTitleOfficeModal: true}));
                                            setCompanyModalStep((prev) => ({
                                                ...prev,
                                                titleCompany: { 
                                                    _id: getTitleCompanySelectedData.titleCompanyId,
                                                    titleCompanyName: getTitleCompanySelectedData.titleOfficeName,
                                                }
                                            }));
                                        }
                                    }}
                                    style={{
                                        cursor: getTitleCompanySelectedData?.inBuilt ? "pointer" : "text",
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Office Address" name="titleOfficeAddress" rules={[{ required: true, message: 'Please enter Office Address' }]}>
                                <Input placeholder='Title Office Address...' disabled={getTitleCompanySelectedData?.inBuilt} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Office Email" name="titleOfficeEmail" rules={[{ type: 'email', message: 'Please enter a valid email.'}]}>
                                <Input placeholder='Title Office Email...' disabled={getTitleCompanySelectedData?.inBuilt} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Office Phone No" name="titleOfficePhoneNo">
                                <PhoneInput inputClass='phoneInput' country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder='Enter Ph. No...'
                                    disabled={getTitleCompanySelectedData?.inBuilt}
                                    inputStyle={{ backgroundColor: getTitleCompanySelectedData?.inBuilt ? "#f5f5f5" : "#fff" }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Office Fax No" name="titleOfficeFaxNo">
                                <PhoneInput inputClass='phoneInput' country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder='Enter Fax No...'
                                    disabled={getTitleCompanySelectedData?.inBuilt}
                                    inputStyle={{ backgroundColor: getTitleCompanySelectedData?.inBuilt ? "#f5f5f5" : "#fff"}}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* SECTION: Title Closer */}
                    <Divider orientation="center" style={{ color: '#2697FF' }}>TITLE CLOSER</Divider>
                    <Row gutter={16}>
                        {/* <Form.Item name="titleCloserId" hidden>
                            <Input />
                        </Form.Item> */}
                        <Col span={12}>
                            <Form.Item
                                label="Closer Name"
                                name="titleCloserName"
                                dependencies={['titleCloserEmail']}
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const email = getFieldValue('titleCloserEmail');
                                            if (email && !value) {
                                                return Promise.reject(new Error('Please enter Closer Name'));
                                            }
                                            return Promise.resolve();
                                        }
                                    })
                                ]}
                            >
                                <Input placeholder='Enter Closer Name...'
                                    readOnly={(getTitleCompanySelectedData?.inBuilt && getTitleCompanySelectedData?.titleCompanyId) ? true : false}
                                    onClick={() => {
                                        if (getTitleCompanySelectedData?.inBuilt && getTitleCompanySelectedData?.titleCompanyId) {
                                            setAuxiliaryModalState((prev) => ({ ...prev, openTitleCloserModal: { openModal: true, target: "CLOSER" } }));
                                            setCompanyModalStep((prev) => ({
                                                ...prev,
                                                titleCompany: {
                                                    _id: getTitleCompanySelectedData.titleCompanyId,
                                                    titleCompanyName: getTitleCompanySelectedData.titleOfficeName,
                                                }
                                            }));
                                        }
                                    }}
                                    style={{ cursor: "pointer" }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Closer Email"
                                name="titleCloserEmail"
                                dependencies={['titleCloserName']}
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const name = getFieldValue('titleCloserName');
                                            if (name && !value) {
                                                return Promise.reject(new Error('Please enter Closer Email'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }),
                                    { type: 'email', message: 'Please enter a valid email.' }
                                ]}
                            >
                                <Input placeholder='Enter Closer Email...'
                                    readOnly={auxiliaryModalState?.updatingData?.salesRep?._id ? true : false}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="Closer Phone" name="titleCloserPhone">
                                <PhoneInput inputClass='phoneInput' country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder='Enter Ph. No...' />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* SECTION: Sales Rep */}
                    <Divider orientation="center" style={{ color: '#2697FF' }}>SALES REP.</Divider>
                    <Row gutter={16}>
                        {/* <Form.Item name="salesRepId" hidden>
                            <Input />
                        </Form.Item> */}
                        <Col span={12}>
                            <Form.Item
                                label="Sales Rep Name"
                                name="salesRepName"
                                dependencies={['salesRepEmail']}
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const email = getFieldValue('salesRepEmail');
                                            if (email && !value) {
                                                return Promise.reject(new Error('Please enter Sales Rep Name'));
                                            }
                                            return Promise.resolve();
                                        }
                                    })
                                ]}
                            >
                                <Input placeholder='Sales Rep Name...'
                                    readOnly={(getTitleCompanySelectedData?.inBuilt && getTitleCompanySelectedData?.titleCompanyId) ? true : false}
                                    onClick={() => {
                                        if (getTitleCompanySelectedData?.inBuilt && getTitleCompanySelectedData?.titleCompanyId) {
                                            setAuxiliaryModalState((prev) => ({ ...prev, openTitleCloserModal: { openModal: true, target: "SALES_REP" } }));
                                            setCompanyModalStep((prev) => ({
                                                ...prev,
                                                titleCompany: {
                                                    _id: getTitleCompanySelectedData.titleCompanyId,
                                                    titleCompanyName: getTitleCompanySelectedData.titleOfficeName,
                                                }
                                            }));
                                        }
                                    }}
                                    style={{ cursor: "pointer" }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Sales Rep Email"
                                name="salesRepEmail"
                                dependencies={['salesRepName']}
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const name = getFieldValue('salesRepName');
                                            if (name && !value) {
                                                return Promise.reject(new Error('Please enter Sales Rep Email'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }),
                                    { type: 'email', message: 'Please enter a valid email.'}
                                ]}
                            >
                                <Input placeholder='Sales Rep Email...'
                                    readOnly={auxiliaryModalState?.updatingData?.salesRep?._id ? true : false}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="Sales Rep Phone" name="salesRepPhone">
                                <PhoneInput inputClass='phoneInput' country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder='Enter Ph. No...'
                                    readOnly={auxiliaryModalState?.updatingData?.salesRep?._id ? true : false}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* SECTION: Processors */}
                    {getTitleCompanySelectedData?.processors?.length > 0 && <Divider orientation="center" style={{ color: '#2697FF' }}>PROCESSORS</Divider>}
                    {getTitleCompanySelectedData?.processors?.map((processor, index) => (
                        <Row gutter={16} key={processor._id}>
                            <Col span={8}>
                                <Form.Item
                                    name={['processors', index, 'name']}
                                    label="Name"
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const email = getFieldValue(['processors', index, 'email']);
                                                if (!value && email) {
                                                    return Promise.reject(new Error('Name is required if email is provided'));
                                                }
                                                return Promise.resolve();
                                            }
                                        })
                                    ]}
                                >
                                    <Input placeholder='Enter Name...' />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    name={['processors', index, 'email']}
                                    label="Email"
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const name = getFieldValue(['processors', index, 'name']);
                                                if (!value && name) {
                                                    return Promise.reject(new Error('Email is required if name is provided'));
                                                }
                                                return Promise.resolve();
                                            }
                                        }),
                                        { type: 'email', message: 'Please enter a valid email.'}
                                    ]}
                                >
                                    <Input placeholder='Enter Email...' />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={['processors', index, 'phoneNumber']} label="Phone Number">
                                    <PhoneInput inputClass='phoneInput' country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder='Enter Ph. No...'
                                        inputStyle={{ width: '200px' }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    ))}

                    {/* SECTION: Affiliates */}
                    {/* <Divider orientation="center" style={{ color: '#2697FF' }}>OTHER / AFFILIATE</Divider>
                    {getTitleCompanySelectedData?.affiliateDetails?.affiliates?.map((affiliate, index) => (
                        <Row gutter={16} key={affiliate._id}>
                            <Col span={6}>
                                <Form.Item
                                    name={['affiliateDetails', 'affiliates', index, 'name']}
                                    label="Name"
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const email = getFieldValue(['affiliateDetails', 'affiliates', index, 'email']);
                                                if (!value && email) {
                                                    return Promise.reject(new Error('Name is required if email is provided'));
                                                }
                                                return Promise.resolve();
                                            }
                                        })
                                    ]}
                                >
                                    <Input placeholder="Enter Name..." />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name={['affiliateDetails', 'affiliates', index, 'email']}
                                    label="Email"
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const name = getFieldValue(['affiliateDetails', 'affiliates', index, 'name']);
                                                if (!value && name) {
                                                    return Promise.reject(new Error('Email is required if name is provided'));
                                                }
                                                return Promise.resolve();
                                            }
                                        }),
                                        { type: 'email', message: 'Please enter a valid email.'}
                                    ]}
                                >
                                    <Input placeholder="Enter Email..." />
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item name={['affiliateDetails', 'affiliates', index, 'role']} label="Role">
                                    <Input placeholder='Enter Role...' />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item name={['affiliateDetails', 'affiliates', index, 'phoneNumber']} label="Phone Number">
                                    <PhoneInput inputClass='phoneInput' country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder='Enter Ph. No...'
                                        inputStyle={{ width: '200px' }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    ))} */}
                </Form>
                {(auxiliaryModalState?.openTitleOfficeModal) ?
                    <Modal
                        open={true}
                        title={<div className='commonModalTitle'>Select Title Office</div>}
                        onCancel={() => {
                            setAuxiliaryModalState((prev) => ({
                                ...prev,
                                openTitleOfficeModal: false,
                                updatingData: { ...prev.updatingData, titleOffice: null }
                            }))
                            setCompanyModalStep((prev) => ({
                                ...prev,
                                titleCompany: {
                                    _id: getTitleCompanySelectedData?.titleCompanyId,
                                    titleCompanyName: getTitleCompanySelectedData?.titleOfficeName,
                                },
                                titleOffice: '',
                            }));
                        }}
                        width={700}
                        okText='Done'
                        onOk={() => {
                            setAuxiliaryModalState((prev) => ({ ...prev, openTitleOfficeModal: false }));
                            updateTheForm({ auxiliaryModalState, updatedWhat: 'TITLE_OFFICE_DATA' });
                        }}
                    >
                        <TitleOffice companyModalStep={companyModalStep} setCompanyModalStep={setCompanyModalStep} setAuxiliaryModalState={setAuxiliaryModalState} modalSource="EDIT_TITLE_COMPANY" />
                    </Modal>
                    :
                    (auxiliaryModalState?.openTitleCloserModal?.openModal && auxiliaryModalState?.openTitleCloserModal?.target) ?
                        <Modal
                            open={true}
                            title={<div className='commonModalTitle'>Select Title {auxiliaryModalState?.openTitleCloserModal?.target === 'CLOSER' ? 'Closer' : 'Rep'} </div>}
                            onCancel={() => {
                                setAuxiliaryModalState((prev) => ({
                                    ...prev,
                                    openTitleCloserModal: { openModal: false, target: null },
                                    updatingData: { ...prev.updatingData, titleCloser: null, salesRep: null }
                                }))
                                setCompanyModalStep((prev) => ({
                                    ...prev,
                                    titleCompany: {
                                        _id: getTitleCompanySelectedData?.titleCompanyId,
                                        titleCompanyName: getTitleCompanySelectedData?.titleOfficeName,
                                    },
                                    titleCloser: '',
                                    salesRep: '',
                                }));
                            }}
                            width={700}
                            okText='Done'
                            onOk={() => {
                                setAuxiliaryModalState((prev) => ({ ...prev, openTitleCloserModal: { openModal: false, target: null } }));
                                updateTheForm({ auxiliaryModalState, updatedWhat: 'TITLE_CLOSER_DATA' });
                            }}
                        >
                            <TitleRepsCloser companyModalStep={companyModalStep} setCompanyModalStep={setCompanyModalStep} setAuxiliaryModalState={setAuxiliaryModalState} auxiliaryModalState={auxiliaryModalState} modalSource="EDIT_TITLE_COMPANY" />
                        </Modal>
                        :
                        <></>
                }
            </div>
        </Modal>
    );
}

export default EditTitleCompanyModal;
